const AppPaths = {
    home: '/',
    about: '/about',
    howToRead: '/how-to-read',
    family: '/family/:id',
};

export default AppPaths;